export const backgroundColorDark = "#2A2E43";
// export const backgroundColorDark = "#98c4db";

export const backgroundColorLight = "#FFFFFF";
export const backgroundColorBlue = "#5773FF";

export const colorBlue = "#5773FF";
export const colorDarkBlue = "#001B8E";

export const colorWhite = "#FFFFFF";
